'use strict';

import angular from 'angular';

import modalDirective from '../../rest-modal';
import template from './template.html';

export default modalDirective({
	controller: controller,
	controllerAs: 'ctrl',
	template: template,
	resolve: {
		phoneNumberList: resolvePhoneNumberList,
		phoneNumber: resolvePhoneNumber,
	}
});


function controller($timeout) {
	'ngInject';

	this.customPhoneNumber = function() {
		// ui-mask has a lot of unaccessible code that handles marking that a
		// change occurred.  This hack seems to work to get around replicating that
		// code here.
		$timeout(function() {
			var input = document.getElementById('call-contact-modal-phone-number');
			angular.element(input).val('');
			input.focus();
			input.blur();
			input.focus();
		}, 0);
	}
}


function resolvePhoneNumber(phoneNumberList) {
	'ngInject';

	try {
		return phoneNumberList[0];
	} catch(e) {
		return '';
	}
}

function processData(response) {
	var data = response.data;
	if(!Array.isArray(data)) {
		data = [data];
	}
	return data;
}


function resolvePhoneNumberList($http, $incident, $context) {
	'ngInject';

	var url;
	if ($context.from) {
		return processData($context.from);
	} else if (url = $incident.phoneFromUrl) {
		return $http.get(url, {cache: false}).then(processData);
	} else if (url = $context.fromUrl) {
		return $http.get(url, {cache: false}).then(processData);
	} else {
		return [];
	}
}


